<div class="relative flex flex-col h-full">
    <div class="h-full rounded-3xl grow p-4 pb-8 mx-6 overflow-y-auto bg-grey-100" #scrollMe>
        <p class="leading-6 relative z-10">
            {{ animatedMessage }}
        </p>
    </div>
    <div class="absolute -bottom-10 size-12 right-[45%] z-0 flex justify-end">
        <svg width="100%" height="100%" viewBox="0 0 100 100">
            <path d="M40 0 L100 0 L0 100 Z" fill="#F0EFEF" />
        </svg>
    </div>
</div>